<template>
  <div class="chat-body__info-search">
    <transition name="search-input">
      <div class="chat-body__info-search-wrap" v-if="isActiveSearchMsg">
        <div class="input-placeholder" v-if="!inputValue" v-html="$t('Search')"></div>
        <button type="button" :class="{'focus': ifFocusInput}">
            <svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"></circle><path d="m21 21-4.3-4.3"></path></svg>
        </button>
        <input id="id" type="text" class="input-lg form-control filter-search-input" 
            autocomplete="off" 
            maxlength="50" 
            :class="{ 'js-loaded': inputValue !== '' }" ref="input"
            v-model="inputValue"
            aria-label="Find user"
            @input="onInput"
            @focus="focusInput()"
            @blur="ifFocusInput = false">
        <div class="chat-body__info-search-wrap-close" @click="toogleSearch(false)">
            <svg class="wc-i" aria-hidden="true" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
        </div>
      </div>
    </transition>
  </div>
  <div class="chat-body__info-right-search" :class="{mini: miniChat}" @click="toogleSearch(true)" v-if="!isActiveSearchMsg">
    <svg v-once class="wc-i" aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></svg>
  </div>
  <transition name="search-result">
     <div class="chat-body__info-search-result" v-if="inputValue.trim().length > 2 && resultSearch && isActiveSearchMsg">
        <div class="chat-body__info-search-result-body" v-if="resultSearch && resultSearch.length > 0">
            <div class="chat-body__info-search-result-count" >
            {{ countCurentSearch + '&nbsp;' + $t('of') + '&nbsp;' + resultSearch.length }}
            </div>
            <div class="chat-body__info-search-result-btns">
            <button @click="btnsSearch('up')" :disabled="countCurentSearch >= resultSearch.length">
                <svg v-once class="wc-i" aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="m18 15-6-6-6 6"/></svg>
            </button>
            <button @click="btnsSearch('down')" :disabled="countCurentSearch <= 1">
                <svg v-once class="wc-i" aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg>
            </button>
            </div>
        </div>
        <div class="chat-body__info-search-result-empty" v-else>
            {{ $t('No results found') }}
        </div>
    </div>
  </transition>

</template>
  
<script>
  import axios from '/webpack-assets/vue/config/axios-config';
  import { chatFetch } from './chatTokenManager';

  export default {
    emits: ['toggle-search', 'find-message', 'active-search-result'],
    data() {
      return {
        countCurentSearch: 0,
        inputValue: '',
        ifFocusInput: false,
        resultSearch: { data: [] },
        searchTimeoutTop: null,
      };
    },
    props: {
      currentUserUuid: {
        type: String,
        required: true,
      },
      testUrlQuickChat: {
        type: String,
        required: true,
      },
      isActiveSearchMsg: {
        type: Boolean,
        required: false,
      },
      miniChat: {
        type: Boolean,
        required: false,
      }
    },
    // beforeUnmount() {
    //     if (this.searchTimeoutTop) {
    //         clearTimeout(this.searchTimeoutTop);
    //         this.searchTimeoutTop = null;
    //     }
    // },
    watch: {
      isActiveSearchMsg(newVal) {
        if (newVal) {
          this.$nextTick(() => {
            this.$refs.input.focus();
          });
        }
      }
    },
    methods: {
        focusInput(){
          this.ifFocusInput = true;
        },
        toogleSearch(bool) {
          this.$emit('toggle-search', bool)
          if(!bool) {
            this.inputValue = '';
            this.resultSearch = {};
            this.countCurentSearch = 0;
          }
        },
        async onInput(event) {
            let inputValue = event.target.value || '';
            this.inputValue = inputValue;
            
            if (this.searchTimeoutTop) {
                clearTimeout(this.searchTimeoutTop);
                this.searchTimeoutTop = null;
            }
            this.$emit('active-search-result', true);
            const trimmed = inputValue.trim();
            
            let params = { 
              conversation_uuid: this.currentUserUuid,
              query: trimmed
            };

            if (!trimmed || trimmed.length < 3) {
                this.resultSearch = {};
                this.countCurentSearch = 0;
                this.$emit('active-search-result', false);
                return;
            }
            const query = new URLSearchParams(params).toString();
            this.searchTimeoutTop = setTimeout(async () => {
              try {
                const response = await chatFetch(`${this.testUrlQuickChat}messages/text-search`, {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify(params),
                });

                const result = await response.json();
                if (result.status !== 'success') return;

                this.resultSearch = result.data;

                this.countCurentSearch = 1;
                const currentMessage = this.resultSearch[0];

                if (currentMessage?.id) {
                    this.$emit('find-message', currentMessage.id);
                }
              } catch (e) {
                console.error(e);
              }
            }, 300);
        },
        btnsSearch(direction) {
            if (!this.resultSearch || this.resultSearch.length === 0) {
                return;
            }

            const length = this.resultSearch.length;
            const maxCount = length;

            if (direction === 'up') {
                if (this.countCurentSearch < maxCount) {
                this.countCurentSearch++;
                }
            } else if (direction === 'down') {
                if (this.countCurentSearch > 1) {
                this.countCurentSearch--;
                }
            }

            if (this.countCurentSearch === 0) {
                return;
            }

            const arrayIndex = this.countCurentSearch - 1;
            const currentMessage = this.resultSearch[arrayIndex];

            if (currentMessage?.id) {
                this.$emit('find-message', currentMessage.id);
            }
        },
    },
  };
  </script>
  
<style lang="scss" scoped>
  .search-result-enter-active,
  .search-result-leave-active {
      transition: height 0.5s ease;
  }

  .search-input-enter-active,
  .search-input-leave-active {
      transition: max-width 0.4s ease;
      width: 0;
  }

  .search-input-enter-from,
  .search-input-leave-to {
    max-width: 0;
    width: 0;
  }

  .search-input-enter-to,
  .search-input-leave-from {
    max-width: 100%;
    width: 100%;
  }

  .search-result-enter-from,
  .search-result-leave-to {
    height: 0;
  }

  .search-result-enter-to,
  .search-result-leave-from {
    height: 100%;
  }
  .chat-body__info-right-search{
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background-color: transparent;
    width: 32px;
    height: 32px;
    min-width: 32px;
    border-radius: 8px;
    transition: background-color 0.2s;
    @media only screen and (max-width: 1023px) {
      width: 40px;
      min-width: 40px;
      height: 40px;
    }
    svg{
      width: 18px;
      height: 18px;
      path{
        transition: 0.3s;
        fill: var(--wc-text-2);
      }
    }
    &:hover{
      @media only screen and (min-width: 1023px) {
        background-color: var(--wc-bg);
      }
    }
  }
  .chat-body__info-search{
    width: 100%;
    padding: 0;
    height: 36px;
    z-index: 2;
    display: flex;
    justify-content: flex-end;
    position: relative;
    transition: opacity 0.4s;
    &-wrap{
      position: absolute;
      top: 0;
      overflow: hidden;
      right: 0;
      width: 100%;
      transition: 0.4s;
      .input-placeholder {
          pointer-events: none;
          position: absolute;
          left: 0;
          overflow-x: hidden;
          height: 36px;
          padding-left: 36px;
          display: inline-block;
          font-family: var(--wc-font);
          font-style: normal;
          font-size: 14px;
          line-height: 36px;
          color: var(--wc-text-3);
          user-select: none;

          b {
              font-weight: 100;
              font-family: "Roboto-Medium";
          }
      }
      button {
          position: absolute;
          left: 0;
          top: 0;
          height: 36px;
          width: 36px;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: transparent;
          border: 0;
          padding: 0;
          color: var(--wc-text-3);
          z-index: 1;
          pointer-events: none;
      }
      input {
          background-color: var(--wc-surface);
          border-radius: 8px;
          border: 1px solid #9DBDFF !important;
          box-shadow: 0 0 0 3px rgba(78, 138, 255, 0.15) !important;
          // room on the right for "2 of 5", the arrows and close (design: all inside the field)
          padding: 0 150px 0 36px;
          height: 36px;
          font-family: var(--wc-font);
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          color: var(--wc-text);
          &::placeholder{
            color: var(--wc-text-3);
          }
          &:focus {
            background-color: var(--wc-surface) !important;
            box-shadow: 0 0 0 3px rgba(78, 138, 255, 0.15);
          }
      }
      &-close{
        height: 32px;
        width: 32px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 8px;
        position: absolute;
        top: 2px;
        right: 2px;
        svg{
          width: 16px;
          height: 16px;
        }
        cursor: pointer;
        svg path{
          transition: 0.4s;
        }
        &:hover{
          svg path{
            fill: var(--wc-text);
          }
        }
      }
    }
    &-result{
      display: flex;
      align-items: center;
      background-color: transparent;
      width: auto;
      height: 32px;
      position: absolute;
      top: 50%;
      right: 40px;
      transform: translateY(-50%);
      // Sits inside the search field, left of its close button; the field ends before
      // the header buttons that follow it (details toggle 32 + menu 32 + gaps)
      .chat-body-head__info-right:has(.chat-body-head__info-userInfo) > &{
        right: 112px;
      }
      .chat-body-head__info-right:not(:has(.chat-body-head__info-userInfo)) > &{
        right: 76px;
      }
      @media only screen and (max-width: 1023px) {
        .chat-body-head__info-right:not(:has(.chat-body-head__info-userInfo)) > &{
          right: 84px;
        }
      }
      overflow: hidden;
      z-index: 3;
      &-count{
        font-family: var(--wc-font);
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
        color: var(--wc-text-2);
      }
      &-btns{
        display: flex;
        align-items: center;
        gap: 0;
        button{
          width: 28px;
          height: 28px;
          border: 0;
          border-radius: 8px;
          background: transparent;
          display: flex;
          align-items: center;
          justify-content: center;
          svg{
            width: 18px;
            height: 18px;
          }
          color: var(--wc-text-2);
          cursor: pointer;
          &:disabled{
            pointer-events: none;
            opacity: 0.5;
          }
          // Instant feedback: no transitions on state change
          &:hover{
            color: var(--wc-text);
            background-color: var(--wc-bg);
          }
        }
      }
      &-body{
        display: flex;
        align-items: center;
        gap: 4px;
        padding: 0;
      }
      &-empty{
        padding: 0 4px;
        white-space: nowrap;
        width: 100%;
        display: flex;
        align-items: center;
        font-family: var(--wc-font);
        font-weight: 400;
        font-size: 12px;
        color: var(--wc-danger);
        line-height: 16px;
      }
    }
  }
</style>